import { Layout, Card, Typography, Button, Space,Flex,Tooltip,Tag } from "antd";

import React, { forwardRef, useEffect, useState, useRef, useMemo } from "react";
import http from "@/utils/http";
import api from "@/utils/api";
import commonFn from "@/utils/commonFn";
import EnhancedTable from "@/hocComponents/EnhancedTable";
import { formatDateText, formatHm, } from "@/utils/date";
import { DownloadOutlined, ReloadOutlined } from "@ant-design/icons";
import "./component/index.css";
import ExportTxtModal from './component/exportTxt';
import DetailModal from "./component/detailModal";
import dayjs from "dayjs";
const MainTable = forwardRef((_props, _ref) => {
  const { Header, Content } = Layout;
  const { Title } = Typography;
  const initTableHead = {
    companyWorkUnder:"",
    accountName: "",
    employeeCode: "",
    supervisorId: undefined,
    employmentTitleId: undefined,
  };
  const [detailLoading, setDetailLoading] = useState(false);
  const [tableHead, setTableHead] = useState(initTableHead);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [supervisorList, setSupervisorList] = useState([]);
 const [exportModalVisible, setExportModalVisible] = useState(false);

  const [employmentList, setEmploymentList] = useState([]);
  const [weekColumns, setWeekColumns] = useState([]);
  const controllersRef = useRef([]);
  const todayRef = useRef("");
  const tableHeadRef = useRef(initTableHead);
  const detailModalRef = useRef(null);
  const createController = () => {
    const controller = new AbortController();
    controllersRef.current.push(controller);
    return controller;
  };

  const cancelAllRequests = () => {
    controllersRef.current.forEach((c) => c?.abort());
    controllersRef.current = [];
  };

  useEffect(() => {
    tableHeadRef.current = tableHead;
  }, [tableHead]);

  const handleFilterChange = (key, value) => {
    setTableHead((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

const handleFilterSubmit = (nextFilters) => {
  let actualFilters = nextFilters;
  if (nextFilters && typeof nextFilters === 'object' && 'companyWorkUnderList' in nextFilters) {
    const { companyWorkUnderList, ...rest } = nextFilters;
    actualFilters = {
      ...rest,
      companyWorkUnder: companyWorkUnderList,
    };
  }
  
  const isEventLike = !!actualFilters && typeof actualFilters === "object" && "target" in actualFilters;

  if (isEventLike || !actualFilters || typeof actualFilters !== "object") {
    getTableListFn(1, 25, tableHeadRef.current);
    return;
  }

  tableHeadRef.current = actualFilters;
  setTableHead(actualFilters);
  getTableListFn(1, 25, actualFilters);
};

  const LEGEND_COLORS = {
    personal: "#CE9EE2",
    annual: "#ADD5C6",
    sick: "#F5B5B5",
    statutory: "#FAC6AB",
  };
  const ZERO_HOUR_BG = "#ffffff";
  const LOW_HOUR_BG = "#DBE8FF";
  const HIGH_HOUR_BG = "#98B5F5";

  const resolveDayTheme = (timeObj = {}) => {
  const marks = Array.isArray(timeObj?.marks) ? timeObj.marks : [];

    // 法定假日
    if (marks.includes(1)) {
      return {
        bg: LEGEND_COLORS.statutory,
        note: timeObj?.holidayName || "Holiday",
      };
    }
 
  // 高工时
    if (marks.includes(2)) {
      return { bg: HIGH_HOUR_BG, note: "" };
    }
    // 0 工时
    if (marks.includes(4)) {
      return { bg: ZERO_HOUR_BG, note: "" };
    }
  // 病假
    if (marks.includes(5)) {
      return { bg: LEGEND_COLORS.sick, note: "" };
    }
   // 年假
    if (marks.includes(6)) {
      return { bg: LEGEND_COLORS.annual, note: "" };
    }
    // （如果恢复低工时）
    // if (marks.includes(3)) {
    //   return { bg: LOW_HOUR_BG, note: "" };
    // }
    if (!marks.length) {
      return { bg: LOW_HOUR_BG, note: "" };
    }

    // 默认（没有任何标记）
    return { bg: ZERO_HOUR_BG, note: "" };
  };
  //  星期列
  const DAY_ORDER = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday",
  ];

const weekColumnFn = (day) => ({
  title: day.charAt(0).toUpperCase() + day.slice(1),
  dataIndex: ["weekMap", day],
  align: "center",
  width: 150,
  onCell: () => ({ style: { padding: 4 } }),
  render: (timeObj = {}, record) => {
    const { hours = 0, minutes = 0 } = timeObj;
    const { bg, note } = resolveDayTheme(timeObj);
    const isToday = !!todayRef.current && timeObj?.date === todayRef.current;
    const isZeroBg = bg === ZERO_HOUR_BG;
    const textColor = "#373D4E";

    const isFutureDate = timeObj?.date && dayjs(timeObj.date).isAfter(dayjs(), 'day');
    
    const isClickable = !isFutureDate && timeObj?.date;

 const handleDateClick = () => {
  if (isClickable) {
    detailModalRef.current?.open({
      accountId: record?.accountId,
      date: timeObj?.date,
    });
  }
};

    // 未来日期的样式
    const futureDateStyle = isFutureDate ? {
      opacity: 0.5,
      cursor: "not-allowed",
    } : {};

    return (
      <div
        style={{
          background: bg,
          borderRadius: 4,
          width: "100%",
          height: "100%",
          minHeight: 70,
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "4px 6px",
          border: isToday
            ? "1px solid #2563EB"
            : isZeroBg
              ? "1px solid #E2E8F0"
              : "1px solid transparent",
          boxShadow: isToday
            ? "4px 4px 4px 4px rgba(105, 147, 238, 0.2)"
            : "none",
          boxSizing: "border-box",
          cursor: isClickable ? "pointer" : isFutureDate ? "not-allowed" : "default",
          transition: isClickable ? "all 0.2s" : "none",
          ...futureDateStyle,
        }}
        onClick={handleDateClick}
        onMouseEnter={(e) => {
          if (isClickable) {
            e.currentTarget.style.transform = "scale(1.02)";
            e.currentTarget.style.boxShadow = "0 2px 8px rgba(37, 99, 235, 0.15)";
          }
        }}
        onMouseLeave={(e) => {
          if (isClickable) {
            e.currentTarget.style.transform = "scale(1)";
            e.currentTarget.style.boxShadow = "none";
          }
        }}
      >
        <div
          style={{
            fontSize: 12,
            color: textColor,
            marginBottom: 10,
            lineHeight: 1.1,
            ...(isFutureDate && { color: "#999" }),
          }}
        >
          {formatDateText(timeObj?.date)}
        </div>

        <div
          style={{
            fontSize: 14,
            fontWeight: 500,
            color: textColor,
            lineHeight: 1.1,
            ...(isFutureDate && { color: "#999" }),
          }}
        >
          {hours} Hrs / {minutes} Min
        </div>
      </div>
    );
  },
});

const getGroupKey = (item = {}) => {

  return `${item.accountName || ""}__${item.employeeCode || ""}__${
    item.supervisorName || ""
  }__${item.companyWorkUnder || ""}`;
  
};
  const getMergedRowData = (list = []) => {
    const nextList = list.map((item) => ({ ...item, _rowSpan: 1 }));

    let startIndex = 0;

    while (startIndex < nextList.length) {
      const currentKey = getGroupKey(nextList[startIndex]);
      let endIndex = startIndex + 1;

      while (
        endIndex < nextList.length &&
        getGroupKey(nextList[endIndex]) === currentKey
      ) {
        endIndex += 1;
      }

      const span = endIndex - startIndex;

      nextList[startIndex]._rowSpan = span;

      for (let i = startIndex + 1; i < endIndex; i++) {
        nextList[i]._rowSpan = 0;
      }

      startIndex = endIndex;
    }

    return nextList;
  };
  const getSupervisorList = async () => {
    const controller = createController();
    const response = await http.get(api.getSupervisorNameDict, {
      signal: controller.signal,
    });
    if (response?.code === "1") {
      const list = (response?.data || []).map((item) => ({
        value: item.accountId,
        label: item.fullName,
      }));
      setSupervisorList(list);
    }
  };
  const getEmploymentTitleList = async () => {
    const response = await http.get(api.employmentTitleDropdown);
    if (response?.code === "1") {
      const list = (response?.data || []).map((item) => ({
        value: item.id,
        label: item.titleName,
      }));
      setEmploymentList(list);
    }
  };

  const getMergeCellProps = (record) => ({
    rowSpan: record?._rowSpan ?? 1,
  });

  const openDetailInNewWindow = (record) => {
    const storageKey = "managerWorkTimeDetailRecord";

    try {
      localStorage.setItem(storageKey, JSON.stringify(record || {}));
    } catch (_e) {
      try {
        sessionStorage.setItem(storageKey, JSON.stringify(record || {}));
      } catch (_e2) {
        // Ignore storage errors; details page will fall back to empty filters.
      }
    }

    window.open(
      "/#/PayRoll/ManagerWorkTimeDetail",
      "_blank",
      "noopener,noreferrer",
    );
  };

  const initColumns = useMemo(() => [
     {
      title: "Company",
      dataIndex: "companyWorkUnder",
      filterKey: "companyWorkUnder",
      width: 150,
      onCell: (record) => getMergeCellProps(record),
    },

    {
      title: "Supervisor Name",
      dataIndex: "supervisorName",
      filterKey: "supervisorId",
      filterType: "select",
      width: 150,
      selectOptions: supervisorList,
      onCell: (record) => getMergeCellProps(record),
    },
 
    {
      title: "Employment Title",
      dataIndex: "employmentTitleName",
      filterKey: "employmentTitleId",
      filterType: "select",
      selectOptions: employmentList,
      width: 150,
      onCell: (record) => getMergeCellProps(record),
    },
       {
      title: "Name",
      dataIndex: "accountName",
      filterKey: "accountName",
      width: 150,
      onCell: (record) => getMergeCellProps(record),
      render: (_value, record) => (
        <span
          style={{ cursor: "pointer", color: "#2563EB" }}
          onClick={() => {
            openDetailInNewWindow(record);
          }}
        >
          {record?.accountName || ""}
          {record?.employeeCode ? ` - ${record.employeeCode}` : ""}
        </span>
      ),
    },
    {
      title: "Reg",
      key: "regMinutes",
      align: "center",
      // width: 140,
      onCell: () => ({ style: { padding: 4 } }),
      render: (_v, record) => (
        <div style={{ fontSize: 14, color: "#2f3a4a", fontWeight: 500 }}>
         {`${Number(record?.regAllHours) || 0} H / ${Number(record?.regAllMinutes) || 0} M`}
        </div>
      ),
    },
     {
      title: "HP",
      key: "hpAllHours",
      align: "center",
      // width: 140,
      onCell: () => ({ style: { padding: 4 } }),
      render: (_v, record) => (
        <div style={{ fontSize: 14, color: "#2f3a4a", fontWeight: 500 }}>
      {`${Number(record?.hpAllHours) || 0} H / ${Number(record?.hpAllMinutes) || 0} M`}
        </div>
      ),
    },
     {
      title: "OT",
      key: "otAllHours",
      align: "center",
      // width: 140,
      onCell: () => ({ style: { padding: 4 } }),
      render: (_v, record) => (
        <div style={{ fontSize: 14, color: "#2f3a4a", fontWeight: 500 }}>
          {`${Number(record?.otAllHours) || 0} H / ${ Number(record?.otAllMinutes) || 0} M`}
        </div>
      ),
    },
     {
      title: "DT",
      key: "dtAllHours",
      align: "center",
      // width: 140,
      onCell: () => ({ style: { padding: 4 } }),
      render: (_v, record) => (
        <div style={{ fontSize: 14, color: "#2f3a4a", fontWeight: 500 }}>
   {`${Number(record?.dtAllHours) || 0} H / ${Number(record?.dtAllMinutes) || 0} M`}
  </div>
      ),
    },
         {
      title: "Annual",
      key: "anAllHours",
      align: "center",
      // width: 140,
      onCell: () => ({ style: { padding: 4 } }),
      render: (_v, record) => (
        <div style={{ fontSize: 14, color: "#2f3a4a", fontWeight: 500 }}>
        {`${Number(record?.anAllHours) || 0} H / ${Number(record?.anAllMinutes) || 0} M`}
        </div>
      ),
    },
      {
      title: "Sick",
      key: "siAllHours",
      align: "center",
      // width: 140,
      onCell: () => ({ style: { padding: 4 } }),
      render: (_v, record) => (
        <div style={{ fontSize: 14, color: "#2f3a4a", fontWeight: 500 }}>
           {`${Number(record?.siAllHours) || 0} H / ${Number(record?.siAllMinutes) || 0} M`}
        </div>
      ),
    },
      {
      title: "Total Hours",
      key: "totalHours",
      align: "center",
      // width: 140,
      onCell: () => ({ style: { padding: 4 } }),
      render: (_v, record) => (
        <div style={{ fontSize: 14, color: "#2f3a4a", fontWeight: 500 }}>
          {`${Number(record?.totalHours) || 0} H / ${Number(record?.totalMinutes) || 0} M`} 
        </div>
      ),
    },
  ], [supervisorList, employmentList]);

  const columns = useMemo(
    () => [...initColumns, ...weekColumns],
    [initColumns, weekColumns],
  );

  //  表格数据
  const getTableListFn = async (_current, _pageSize, queryTableHead = {}) => {
    const controller = createController();
    const searchParams = {
      ...initTableHead,
      ...queryTableHead,
    };
    const params = {};
    const accountName = String(searchParams.accountName ?? "").trim();
    const employeeCode = String(searchParams.employeeCode ?? "").trim();
    const employmentTitleId = searchParams.employmentTitleId;
    const supervisorId = searchParams.supervisorId;
     const companyWorkUnder = String(searchParams.companyWorkUnder ?? "").trim(); 
    if (accountName) params.accountName = accountName;
    if (employeeCode) params.employeeCode = employeeCode;
    if (companyWorkUnder) params.companyWorkUnder = companyWorkUnder;
    if (
      employmentTitleId !== null &&
      employmentTitleId !== undefined &&
      String(employmentTitleId).trim() !== ""
    ) {
      params.employmentTitleId = employmentTitleId;
    }
    if (
      supervisorId !== null &&
      supervisorId !== undefined &&
      String(supervisorId).trim() !== ""
    ) {
      params.supervisorId = supervisorId;
    }

    const hasParams = Object.keys(params).length > 0;
    setTableLoading(true);

    try {
      const response = await http.post(
        api.managerWorkTimeShowV2,
        hasParams ? params : undefined,
        {
          signal: controller.signal,
        },
      );

      if (!response) return;

      if (response.code !== "1") {
        commonFn.modalFailedFn(response);
        return;
      }

      todayRef.current = response.data?.today || "";

      const firstWeekMap = response.data?.list?.[0]?.weekMap || {};
      const fallbackWeekList = DAY_ORDER.filter((day) => firstWeekMap?.[day]);
      const weekList = response.data?.weekColumns?.length
        ? response.data.weekColumns
        : fallbackWeekList;

      setWeekColumns(weekList.map((day) => weekColumnFn(day)));

      const rawList = (response.data.list || []).map((item, index) => ({
        ...item,
        "#": index + 1,
      }));

      const mergedList = getMergedRowData(rawList);
      setTableList(mergedList);
    } finally {
      setTableLoading(false);
    }
  };
  const handleRefresh = () => {
    getTableListFn(1, 25, tableHeadRef.current);
  };

   const handleExportTxt = () => {
    setExportModalVisible(true);
  };

  // 关闭导出弹窗
  const handleCloseExportModal = () => {
    setExportModalVisible(false);
  };

  useEffect(() => {
    getTableListFn(1, 25);
    getSupervisorList();
    getEmploymentTitleList();
    return () => {
      cancelAllRequests();
    };
  }, []);
  return (
    <div className="dashboard-layout-payroll">
      <Header className="dashboard-header">
        <div className="dashboard-header-left">
          <Title level={4}>Manager Work Time</Title>
        </div>
      </Header>

      <Content style={{ marginTop: 10 }}>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              padding: "10px 0",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 12,
            }}
          >
            <div>
   
             {(commonFn.btnAuthorityFlag("ExportTXT") && (
            <Space size="large">
          <Button className="btnNew" onClick={handleExportTxt}>
           Export TXT
          </Button>
            </Space>
          )) ||
            null}
     
            </div>
            <div
              style={{
                display: "flex",
                gap: 14,
                flexWrap: "wrap",
                fontSize: 16,
              }}
            >
              <span>
                <span style={{ color: LEGEND_COLORS.annual }}>■</span> Annual
              </span>
              <span>
                <span style={{ color: LEGEND_COLORS.sick }}>■</span> Sick
              </span>
              <span>
                <span style={{ color: LEGEND_COLORS.statutory }}>■</span>Holiday
              </span>
              <span>
                <span style={{ color: LOW_HOUR_BG, marginRight: 6 }}>■</span>
                &lt;8 Hrs
              </span>
              <span>
                <span style={{ color: HIGH_HOUR_BG, marginRight: 6 }}>■</span>
                &gt;8 Hrs
              </span>
            </div>

            {/* <Space> */}
            <Button
              icon={<ReloadOutlined />}
              onClick={handleRefresh}
              loading={detailLoading}
            >
              Refresh
            </Button>
    
          </div>

          <EnhancedTable
            rowKey={(record, index) => `${record.accountId}_${index}`}
            columns={columns}
            dataSource={tableList}
            loading={tableLoading}
            rowClassName={(record) =>
              record?._rowSpan > 0 ? "manager-group-start" : ""
            }
            pagination={false}
            rowSelection={undefined}
            filters={tableHead}
            onFilterChange={handleFilterChange}
            onFilterSubmit={handleFilterSubmit}
            scroll={{
              x: "max-content",
              y: "calc(100vh - 350px)",
            }}
          />
        <ExportTxtModal
        visible={exportModalVisible}
        onCancel={handleCloseExportModal}
      /> 

<DetailModal
  ref={detailModalRef}
  onSuccess={() => {
    handleRefresh();
  }}
/>

      </Content>
    </div>
  );
});

export default MainTable;
